import { useEffect, useState } from "react";
import { ButtonArrow, Container, FreeWrapper, LinkArea, Ooppah, TextInfo } from "./style";
import { objectIsEmpty } from "../../../Support/Util";
import LeftArrow from './../../../Assets/icons/F5.svg';
import RightArrow from './../../../Assets/icons/E5.svg';
import Modal from "../../Modal";

const Photoslider = ({currentSliderImage, setCurrentSliderImage, photos}) => {

    const [imageDimension, setImageDimension] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const homePlansUrl = `${process.env.REACT_APP_HOME_URL}/plans`;
    const productOoppahStoreUrl = "https://www.store.ooppah.com";
    

    const openModalInfoPhotos = () => setModalOpen(true);
    const closeModalInfoPhotos = () => setModalOpen(false);

    const defineImageStyle = () => {
        if(objectIsEmpty(imageDimension)){
            return ({width: 0, height: 0});
        }

        let srcWidth = imageDimension.width;
        let srcHeight = imageDimension.height;
        
        let maxWidth = window.innerWidth * 0.8;
        let maxHeight = window.innerHeight * 0.7;

        let ratio = Math.min(maxWidth/srcWidth, maxHeight/srcHeight);

        console.log({width: srcWidth*ratio, height: srcHeight*ratio});
        return ({width: srcWidth*ratio, height: srcHeight*ratio});
    }

    const getImageSize = () => {
        const image = new Image();
        image.src = photos[currentSliderImage].original_url;
        image.onload = () => {
            setImageDimension({
                width: image.width,
                height: image.height
            })
        };
    }


    const onBackHandle = () => {
        const length = photos.length;
        let newSliderImage = currentSliderImage;
        newSliderImage = newSliderImage - 1;
        if(newSliderImage == -1){
            newSliderImage = length - 1;
        }
        setCurrentSliderImage(newSliderImage);
    }

    const onFowardHandle = () => {
        const length = photos.length;
        let newSliderImage = currentSliderImage;
        newSliderImage = newSliderImage + 1;
        if(newSliderImage == length){
            newSliderImage = 0;
        }
        setCurrentSliderImage(newSliderImage);

    }

    useEffect(() => {
        if(photos[currentSliderImage]){
            getImageSize();
        }
    }, [currentSliderImage, photos]);

    return (
        <Container>
            <ButtonArrow onClick={onBackHandle}>
                <img src={LeftArrow} width={30} height={30}/>
            </ButtonArrow>
            <div style={{display: "flex", flexDirection: "column"}}>
                {photos[currentSliderImage].should_blur &&
                <FreeWrapper> 
                    <span>Imagem indisponível para exibição!</span>
                    <button onClick={openModalInfoPhotos}>Saiba mais!</button>
                </FreeWrapper>
                }
                <img src={photos[currentSliderImage] ? photos[currentSliderImage].original_url:''} style={ photos[currentSliderImage] ? defineImageStyle():{width: 0, height: 0} } /> 
            </div>
            <ButtonArrow onClick={onFowardHandle}>
                <img src={RightArrow} width={30} height={30}/>
            </ButtonArrow>

            <Modal isOpen={modalOpen} handleClose={closeModalInfoPhotos}>
              <TextInfo>
                <span>Você ultrapassou o limite de fotos do seu plano!</span>
                <span>Mais fotos aumentam em até 4x suas chances de escalação!</span>
                <span>
                  <LinkArea href={homePlansUrl} target="_blank">Confira nossos planos!</LinkArea> 
                </span> 
                <span>Não tem foto atual? O <Ooppah>Ooppah</Ooppah> resolve!</span> 
                <LinkArea href={productOoppahStoreUrl} target="_blank">
                  Realizamos sessões de fotos profissionais no Rio de Janeiro.
                </LinkArea>
              </TextInfo>
            </Modal>
        </Container>
    );
}

export default Photoslider;